import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { graphql, readInlineData } from 'react-relay';

import { abTestHelper_viewer$key } from './__generated__/abTestHelper_viewer.graphql';

const viewerFragment = graphql`
    fragment abTestHelper_viewer on Viewer @inline {
        sponsoredListing: featureFlag(feature: "sponsoredListing")
    }
`;

export const PERSONALIZED_RERANK_TEST_NAME = 'Personalized-Rerank' as const;

export const isPersonalizedRerankAbTestVariant = (): boolean =>
    getAbTestV2(PERSONALIZED_RERANK_TEST_NAME)?.variant === 'variant';

export const includeSponsoredListing = ({
    viewer: viewerRef,
}: {
    viewer: abTestHelper_viewer$key | null;
}): boolean => {
    const viewer = readInlineData(viewerFragment, viewerRef);
    const sponsoredListingEnabled = !!viewer?.sponsoredListing;
    return sponsoredListingEnabled;
};
